<div *ngIf="isWhiteLabel; else noCompany">
    <div class="powered-by" *ngIf="currentCompany$ | async as company">
        <img
            [src]="appLogo"
            class="d-inline-block align-top main-logo"
            title="Logo"
            alt="Logo entreprise"
        />
        <div>
            <span>Powered by</span>
            <img
                src="/assets/logo-200.png"
                class="d-inline-block align-top powered-by-logo"
                alt="Logo"
            />
        </div>
    </div>
</div>
<ng-template #noCompany>
    <img
        src="/assets/logo-200.png"
        class="d-inline-block align-top main-logo"
        alt="Logo"
    />
</ng-template>
<!--<nb-menu *ngIf="hasTree" [items]="tree">
</nb-menu>-->
<on-menu *ngIf="hasTree" [items]="tree"> </on-menu>
